module.exports = __webpack_public_path__ + "static/img/produce06.f3c9a41.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/produce06.png
// module id = 136
// module chunks = 4